import { render, staticRenderFns } from "./ManageUserHeader.vue?vue&type=template&id=e5d3e9bc&"
import script from "./ManageUserHeader.vue?vue&type=script&lang=js&"
export * from "./ManageUserHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports